import { Backbone } from "js/vendor";

const PageView = Backbone.View.extend({
    menuType: null
});

export default PageView;
